import React from 'react';
import { Container } from './styles';
import { styled as MuiStyled } from "@mui/material/styles";
import { useAccessibility } from '@/hooks/useAccessibility';
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { useFloatingFilterButton } from '@/services/zustand/flotingFilterButton';
import { LinesIcon } from '../../planos_municipais/partials/Filter/partials/svg/GradientLines';

export const BootstrapTooltip = MuiStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#FDF6DA",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FDF6DA",
    color: "rgba(0, 0, 0, 0.87)",
    padding: "1rem",
    maxWidth: 220,
    boxShadow: "5px 6px 11px 0px rgba(0, 0, 0, 0.16)",
  },
}));

export const FloatingFilterButton: React.FC = () => {
  const isOpen = useFloatingFilterButton(state => state.open);
  const toggle = useFloatingFilterButton(state => state.toggle);
  const { floatinButtonRef, isFixedPosition } = useAccessibility();

  return (
    <BootstrapTooltip placement='top' title='Filtros'>
      <Container ref={floatinButtonRef} isFixed={isFixedPosition} isOpen={isOpen} onClick={toggle}>
        <LinesIcon />
      </Container>
    </BootstrapTooltip>
  );
};